import { tv } from 'tailwind-variants';

import { createHeadingTextComponent, type HeadingTextProps } from './utils';

const headlineVariants = tv({
    base: ['m-0', 'font-kalshi-condensed'],
    variants: {
        size: {
            x10: 'typ-headline-x10',
            x15: 'typ-headline-x15',
            x20: 'typ-headline-x20',
        },
        balance: {
            true: 'text-balance',
        },
        medium: {
            true: 'font-medium',
        },
        semibold: {
            true: 'font-semibold',
        },
        underline: {
            true: 'underline-link',
        },
    },
    defaultVariants: {
        balance: false,
    },
});

/**
 * Headline Components
 *
 * Medium-weight headlines for content sections.
 * Uses KalshiSans Condensed Medium font.
 *
 * @example
 * <Headline.x10 as="h2">Popular Markets</Headline.x10>
 * <Headline.x20 as="h1">Trending Now</Headline.x20>
 * <Headline.x10 balance={false}>FAQ</Headline.x10>
 */
export const Headline = {
    /** Headline x10 - 24px/28px, KalshiSans Condensed Medium */
    x10: createHeadingTextComponent(headlineVariants, 'Headline.x10', 'x10'),
    /** Headline x15 - 18px/26px, KalshiSans Condensed Semibold */
    x15: createHeadingTextComponent(headlineVariants, 'Headline.x15', 'x15'),
    /** Headline x20 - 30px/36px, KalshiSans Condensed Medium */
    x20: createHeadingTextComponent(headlineVariants, 'Headline.x20', 'x20'),
} as const;

export default Headline;
export { headlineVariants };
export type HeadlineProps = HeadingTextProps;
